export default "__VITE_ASSET__BzKiex4$__"